import { createContext, useContext } from 'react';
import type { HealthStatus } from '../hooks/useHealthCheck';

/**
 * issue #53: useHealthCheck の戻り値を全 page から参照できるようにする Context。
 * App.tsx で <HealthStatusContext.Provider value={useHealthCheck()}> として上位 inject、
 * Footer / Header / その他配下で `useHealthStatus()` で取得する。
 *
 * value=null は Provider 外で useHealthStatus を呼んだ場合の sentinel (test 用途含む)。
 */
export const HealthStatusContext = createContext<HealthStatus | null>(null);

export function useHealthStatus(): HealthStatus | null {
  return useContext(HealthStatusContext);
}
